import Vue from 'vue';
import { mapGetters } from 'vuex';

const TeacherPermissionsMixin = Vue.extend({
  computed: {
    ...mapGetters({
      teacherPermissions: 'user/teacherPermissions',
    }),
    videoUploadAllowed() {
      // @ts-ignore
      return this.hasPermission('has_video_upload');
    },
    hasPageBuilder() {
      // @ts-ignore
      return this.hasPermission('has_page_builder');
    },
  },
  methods: {
    hasPermission(permission) {
      if (!this.teacherPermissions) return false;
      return this.teacherPermissions[permission] || false;
    },
  },
});
export default TeacherPermissionsMixin;
